// Where the viewer's API lives, decided in exactly one place.
//
// Two things depend on this answer and must never disagree: the bundle, which
// sends every request there, and the Content-Security-Policy in dist/_headers,
// whose connect-src, media-src, frame-src and img-src name that origin and
// nothing else. vite.config.ts imports this module and writes the origin into
// the built _headers, so a build pointed at a different API (VITE_API_BASE)
// ships a policy that allows that API -- rather than a policy that silently
// blocks every share from loading.
//
// Dependency-free and DOM-free on purpose: it is loaded by the Vite config in
// Node as well as by the app in the browser.

/** The live signal API. A production build with no VITE_API_BASE uses this. */
export const PRODUCTION_API_BASE = 'https://api.plexiidesk.com'

/** The local signal server, for `vite` dev and any non-production build. */
export const DEVELOPMENT_API_BASE = 'http://localhost:8787'

/**
 * The API base for a build. A production build with VITE_API_BASE unset must
 * not fall back to localhost: the deploy would look fine and every share would
 * fail to load. Same pattern the brochure uses for the same reason.
 */
export function resolveApiBase(explicit: string | undefined, isProduction: boolean): string {
  const base = (explicit ?? '').trim() || (isProduction ? PRODUCTION_API_BASE : DEVELOPMENT_API_BASE)
  return base.replace(/\/+$/, '')
}

/**
 * A token-scoped desk asset. Both parts are encoded: an asset id is one path
 * segment, never "../" or "?x=" into some other API route.
 */
export function deskAssetUrl(apiBase: string, token: string, assetId: string): string {
  return `${apiBase}/share/${encodeURIComponent(token)}/desk/assets/${encodeURIComponent(assetId)}`
}
